import React from 'react';

import PropTypes from 'prop-types';

import {
  Modal,
  Overlay,
  ExtendedBox,
} from '..';

const ModalWithOverlay = ({
  isVisible,
  handleClick,
  children,
  full,
}) => {
  return (
    <ExtendedBox
      w={1}
      height="100%"
      position="fixed"
      left="0"
      top="0"
      visibility={isVisible ? 'visible' : 'hidden'}
      display={isVisible ? 'block' : 'none'}
      zIndex="2"
    >
      <Overlay
        isVisible={isVisible}
        handleClick={handleClick}
      />
      <Modal
        isVisible={isVisible}
        handleClick={handleClick}
        full={full}
      >
        {children}
      </Modal>
    </ExtendedBox>
  );
};

ModalWithOverlay.propTypes = {
  children: PropTypes.any,
  isVisible: PropTypes.bool,
  handleClick: PropTypes.func,
  full: PropTypes.bool,
};

export default ModalWithOverlay;
